__turbopack_context__.v({
  "root": "styles-module-scss-module__E5Rs2G__root",
});
